import { ComponentMap } from "../common/ComponentMap";

interface LayoutBlock {
  id: number;
  component: number;
  props?: Record<string, unknown>;
}

interface Props {
  layoutData: LayoutBlock[];
}

export default function HomeLayout({ layoutData }: Props) {
  return (
    <>
      {layoutData.map((block) => {
        const Component = ComponentMap[block.component];
        if (!Component) return null;
        return <Component key={block.id} {...(block.props || {})} />;
      })}
    </>
  );
}
